import React from 'react'
import styled from '@emotion/styled'
import { HiTrendingUp } from 'react-icons/hi'

const StyledBox = styled('fieldset')`
  height: 350px;
  width: 300px;
  border: 1px solid #F0C17D;
  box-sizing: border-box;
  grid-area: 1 / 1;
  padding: 10px;
`
const StyledLegend = styled('legend')`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #F0C17D;
  margin: auto;
  padding: 0 8px;
`

const Content = styled('div')`
  display: flex;
  flex-direction: column;
`

const StyledItem = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const StyledBadge = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 6px;
  margin: 2px 0;
  background: #F0C17D; //#36174D
  //box-shadow: inset 0px 0px 5px 4px #F0C17D;
  border-radius: 10px;
  color: #36174D;
`

const PremiumFeatures = (props) => {
  const { tittle, items } = props
  return (
    <>
      <StyledBox>
        <StyledLegend>{tittle}</StyledLegend>
        <Content>
          {items && (items.map((item, index) => (
            <StyledItem key={index}>
              <div>
                {item.text}
              </div>
              {item.badge && (
                <StyledBadge>
                  Up
                  <HiTrendingUp style={{marginLeft: "1px"}}/>
                </StyledBadge>
              )}
            </StyledItem>
          )))}
        </Content>
      </StyledBox>
    </>
  )
}

export default PremiumFeatures
